module.exports = __webpack_public_path__ + "img/cut_height1.580748ac.png";